import { styled } from "@mui/material";
import { solitude } from "shared/assets/colors";

const PREFIX = "UserGroupOverviewStyles";
export const classes = {
  table: `${PREFIX}-table`,
};

export const Root = styled("div")(() => ({
  [`& .${classes.table}`]: {
    border: `1px solid ${solitude}`,
    borderCollapse: "separate",
    fontSize: 10,
    borderSpacing: "5px !important",
  },
}));
